import { INDUSTRIES, studiesByIndustry } from "@/content/case-studies";
import { cn } from "@/lib/utils";

interface IndustryRailProps {
  /** Index of the industry currently in view (driven by scroll). */
  activeIndex: number;
}

// Passive scroll indicator (not clickable): the active industry's marker grows
// into an elongated pill as the pinned section crossfades to it.
export function IndustryRail({ activeIndex }: IndustryRailProps) {
  return (
    <nav aria-hidden className="relative flex flex-col gap-7 pl-0.5">
      <span className="absolute bottom-2 left-[5.5px] top-2 w-px bg-[#1c1e20]" />
      {INDUSTRIES.map((industry, i) => {
        const count = studiesByIndustry(industry.id).length;
        const active = i === activeIndex;
        return (
          <div key={industry.id} className="relative flex items-start gap-3.5">
            <span
              className={cn(
                "mt-1 w-2 flex-none rounded-full transition-all duration-300",
                active ? "h-11 bg-[#f2f2f2]" : "h-2 bg-[#3a3c3e]",
              )}
            />
            <span>
              <span
                className={cn(
                  "block text-[0.92rem] font-medium leading-tight transition-colors duration-300",
                  active ? "text-[#f2f2f2]" : "text-[#7c7e80]",
                )}
              >
                {industry.short}
              </span>
              <span className="mt-1 block text-[0.71rem] tracking-wide text-[#7c7e80]">
                {count} case stud{count > 1 ? "ies" : "y"}
              </span>
            </span>
          </div>
        );
      })}
    </nav>
  );
}
